var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"progress-indicator",class:{'progress-indicator--hidden': _vm.isWelcome},style:({ '--width': _vm.progress + '%' })})
}
var staticRenderFns = []

export { render, staticRenderFns }